const warnedMessagesByNamespace = new Map<string, Set<string>>();

function ledgerFor(namespace: string): Set<string> {
  let ledger = warnedMessagesByNamespace.get(namespace);
  if (!ledger) {
    ledger = new Set<string>();
    warnedMessagesByNamespace.set(namespace, ledger);
  }
  return ledger;
}

/** Emit a console warning at most once per `(namespace, message)` pair. */
export function warnOnce(namespace: string, message: string): void {
  const ledger = ledgerFor(namespace);
  if (ledger.has(message)) {
    return;
  }
  ledger.add(message);
  // eslint-disable-next-line no-console
  console.warn(message);
}

/** Test-only reset for one or all warn-once ledgers. */
export function resetWarnOnce(namespace?: string): void {
  if (namespace === undefined) {
    warnedMessagesByNamespace.clear();
    return;
  }
  warnedMessagesByNamespace.get(namespace)?.clear();
}
